var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { normalizeColorKey } from "../utils/chartConstants";
var Sparkline = function (_a) {
    var points = _a.points, color = _a.color;
    var width = 92;
    var height = 34;
    var safePoints = points.map(function (point) { return point !== null && point !== void 0 ? point : 0; });
    var maxValue = Math.max.apply(Math, __spreadArray(__spreadArray([], safePoints, false), [1], false));
    var stepX = points.length > 1 ? width / (points.length - 1) : width;
    var linePoints = points
        .map(function (point, index) {
        var value = point !== null && point !== void 0 ? point : 0;
        var x = index * stepX;
        var y = height - (value / maxValue) * (height - 6) - 3;
        return "".concat(x, ",").concat(y);
    })
        .join(" ");
    var areaPoints = "0,".concat(height, " ").concat(linePoints, " ").concat(width, ",").concat(height);
    return (_jsxs("svg", __assign({ width: width, height: height, viewBox: "0 0 ".concat(width, " ").concat(height) }, { children: [_jsx("defs", { children: _jsxs("linearGradient", __assign({ id: "spark-".concat(normalizeColorKey(color)), x1: "0", y1: "0", x2: "0", y2: "1" }, { children: [_jsx("stop", { offset: "0%", stopColor: color, stopOpacity: "0.28" }), _jsx("stop", { offset: "100%", stopColor: color, stopOpacity: "0.02" })] })) }), _jsx("polygon", { points: areaPoints, fill: "url(#spark-".concat(normalizeColorKey(color), ")") }), _jsx("polyline", { points: linePoints, fill: "none", stroke: color, strokeWidth: "2", strokeLinejoin: "round", strokeLinecap: "round" })] })));
};
export default Sparkline;
